import { AfterViewInit, ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { UtilsProvider } from "../../../common/providers/utils-provider.service";
import { TranslateService } from '@ngx-translate/core';
import { ConfigProvider } from "../../../config-provider.service";
import { CurrentUser } from "../../../common/providers/current-user";
import { OrganizationsProvider } from '../../providers/organizations-provider';
import { OrganizationsNavigationProvider } from '../../providers/navigation-provider';
import { CurrentUserRolesProvider } from '../../providers/current-user-roles-provider';
import { OrganizationRights } from '../../providers/organization-rights';
import { BreadcrumbProvider } from '../../../breadcrumb/providers/breadcrumb-provider';
import { Observable, tap } from "rxjs";
import { map } from "rxjs/operators";
import { MenuItem } from "../../../common/models/menu";
import { Organization } from "../../../common/models/organization";
import { PageContentComponent } from "../../../common/components/page-content/page-content";
import { HeaderComponent } from "../../../common/components/header-elitment/header-elitment";
import { SideMenuComponent } from "../../../common/components/side-menu/side-menu";
import { NgIf } from "@angular/common";
import { Error401Component } from "../../../common/components/error-401/error-401";
import { FooterComponent } from "../../../common/components/footer-elitment/footer-elitment";

@Component({
  selector: 'organizations-settings-page',
  providers: [],
  styleUrls: ['./settings.scss'],
  standalone: true,
  imports: [
    PageContentComponent,
    HeaderComponent,
    SideMenuComponent,
    NgIf,
    Error401Component,
    FooterComponent
  ],
  templateUrl: './settings.html'
})
export class OrganizationsSettingsPageComponent implements AfterViewInit {
    public backUrl: string | null = null;
    public pageTitle = 'Settings';
    public menus: MenuItem[] = [];

    public is401 = false;

    public organization: Organization  | null = null;
    public organizationRights: OrganizationRights = new OrganizationRights(this._utils);
    constructor(
        public conf: ConfigProvider,
        public breadcrumbProvider: BreadcrumbProvider,
        public currentUser: CurrentUser,
        private _utils: UtilsProvider,
        private _title: Title,
        private _router: Router,
        private _route: ActivatedRoute,
        private _changeDetector: ChangeDetectorRef,
        private _navigation: OrganizationsNavigationProvider,
        private _translater: TranslateService,
        private _currentUserRoles: CurrentUserRolesProvider,
        private _organizations: OrganizationsProvider,
    ) {
    }

    public ngAfterViewInit() {
        this.loadOrganization().subscribe({
            next: () => {
                this.initNav();
            },
            error: (error) => {
                this.onError(error);
            }
        })
    }

    public onError(error: any): void {
        console.error("Settings : ", error);
    }

    private loadOrganization(): Observable<void> {
      return this._navigation.getOrganisationFromRoute().pipe(
        map((organization: Organization|null) => {
          if (organization) {
            this.organization = organization;
            this.organizationRights.evaluate({
              organization: this.organization,
              user: this.currentUser.user!,
              rolesIds: this._currentUserRoles.getRolesIds(this.organization.id!)
            });
          } else {
            throw { error: 'Organization not found', status: 404 };
          }
        })
      );
    }

    private initNav(): void {
        this._title.setTitle(this._translater.instant('Organization_settings') + ' | ' + this.conf.platformName);
        this.menus = this._navigation.getMenus('settings', {
            organization: this.organization!,
            rights: this.organizationRights
        });
        this.backUrl = '/' + this.organization!.code;

        this.is401 = !this.organizationRights.EDIT;
        this.breadcrumbProvider.setDefaultCrumbs([]);
    }
}
